import script from "./CalcStatChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcStatChip.vue?vue&type=script&setup=true&lang=js"

import "./CalcStatChip.vue?vue&type=style&index=0&id=6392273c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6392273c"]])

export default __exports__